import * as React from 'react';
import { withDataFetchNivo } from '../hoc/withDataFetchNivo';

const ResponsiveChoropleth: any = React.lazy(() =>
  import('@nivo/geo').then(module => ({ default: module.ResponsiveChoropleth }))
);

const ChoroplethWidget: React.FC<any> = ({ data }) => {
  const {
    margin,
    features,
    colors,
    domain,
    legends,
    projectionTranslation,
    projectionRotation,
  } = data.view;

  return (
    <React.Suspense fallback="loading...">
      <ResponsiveChoropleth
        data={data.data}
        features={features.features}
        margin={margin}
        colors={colors}
        domain={domain}
        unknownColor="#666666"
        label="properties.name"
        valueFormat=".2s"
        projectionTranslation={projectionTranslation}
        projectionRotation={projectionRotation}
        enableGraticule={true}
        graticuleLineColor="#dddddd"
        borderWidth={0.5}
        borderColor="#152538"
        legends={legends}
      />
    </React.Suspense>
  );
};

export default withDataFetchNivo(ChoroplethWidget);
